// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1AAWyQJ4LX_Ioq {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 600px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardDetailLoading": "_1AAWyQJ4LX_Ioq"
};
export default ___CSS_LOADER_EXPORT___;
